module.exports = __webpack_public_path__ + "img/img26.697e27c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/07/img26.jpg
// module id = 292
// module chunks = 0